import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, Card, CardHeader, CardBody } from 'reactstrap'
import { addCustFileUploadReset, addCustFileUploadStart, getCustBulkUpload, revertBulkUpload } from 'store/actions'
import Loader from "common/Loader"
import { toast } from 'react-toastify'
import bulkCustFormat from "./BulkCustFormat/bulkCustomers.xlsx"
import moment from 'moment'
import TableContainer from 'components/Common/TableContainer'

const CustBulkUpload = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { uploaded, uploading, bulkupload, successMsg, error, bulkCustList } = useSelector(state => state.fileUploadReducer);

    const [modalOpen, setModalOpen] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [selectedBulk, setSelectedBulk] = useState(null);
    const [revertModal, setRevertModal] = useState(false)


    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: ({ row }) => {
                    return <>{row.index + 1}</>;
                },
            },
            {
                Header: "File Name",
                accessor: "filename",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original.filename.substring(cellProps.row.original.filename.lastIndexOf('/') + 1)}
                        </>
                    );
                },
            },
            {
                Header: "Upload Name",
                accessor: "upload_name",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original.upload_name}
                        </>
                    );
                },
            },
            {
                Header: "Total Records",
                accessor: "total_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.total_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Inserted Records",
                accessor: "inserted_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.inserted_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Updated Records",
                accessor: "updated_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.updated_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Failed Records",
                accessor: "failed_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.failed_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Duplicate Records",
                accessor: "duplicate_records",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.duplicate_records : ""}
                        </>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row.original ? cellProps.row.original.status : ""}
                        </>
                    );
                },
            },

            {
                Header: "Date",
                accessor: "date",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <>
                            {cellProps.row?.original?.date ? moment(cellProps.row.original.date).format("DD/MM/YYYY") : ""}
                        </>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "lead_status",
                filterable: true,
                Cell: cellProps => {
                    return (
                        <Button
                            color={cellProps.row.original.status !== "Reverted" ? 'primary' : 'secondary'}
                            style={{ minWidth: "130px", fontSize: "10px" }}
                            disabled={cellProps.row.original.status == "Reverted"}
                            onClick={() => {
                                setSelectedBulk(cellProps.row.original)
                                setRevertModal(true)
                            }}
                        >
                            Revert
                        </Button>
                    );
                },
            },
        ],
        []
    );

    const toggleModal = () => {
        setModalOpen(!modalOpen)
        dispatch(addCustFileUploadReset())
    }

    const handleFileChange = e => {
        const file = e.target.files[0]
        if (file) {
            if (
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "text/csv"
            ) {
                setSelectedFile(file)
            } else {
                toast.error("Please select a valid Excel or CSV file.")
            }
        }
    }

    const downloadCSV = () => {

        const a = document.createElement("a")
        a.href = bulkCustFormat
        a.download = "CustomerBulkUploadFormat.xlsx"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    const handleFileUpload = e => {
        e.preventDefault()
        const formData = new FormData()
        formData.append("uploadName", "bulk_customer")
        formData.append("CustomersFile", selectedFile)
        dispatch(addCustFileUploadStart(formData))
        // setModalOpen(false)
    }


    const HandleRevertBulk = () => {
        dispatch(revertBulkUpload({ "bulkupload_id": selectedBulk.id, "upload_type": "customers" }))
        setRevertModal(false)
    }



    useEffect(() => {
        if (uploaded) {
            dispatch(getCustBulkUpload())
        }
    }, [uploaded])


    useEffect(() => {
        dispatch(getCustBulkUpload())
    }, [])
    useEffect(() => {
        if (successMsg && successMsg !== null) {
            toast.success(successMsg)
        }
    }, [successMsg])

    useEffect(() => {
        toast.error(error)
    }, [error])
    return (
        <div className='page-content'>
            <div className='d-flex justify-content-between align-items-center'>
                <h2>Customer Bulk Upload</h2>

                <div>
                    <Button
                        color='primary'
                        onClick={toggleModal}
                    >New Bulk Upload</Button>
                    <button
                        onClick={() => navigate(-1)}
                        className="btn btn-light ms-2"
                    >
                        Back
                    </button>
                </div>
            </div>



            <div>
                {/* Tables DIv */}
                <TableContainer
                    columns={columns}
                    Loading={uploading}
                    data={bulkCustList}
                    isGlobalFilter={false}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={20}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
            </div>

            {/* Create Bulk Upload Modal */}
            <div>

                <Modal isOpen={modalOpen} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                        Upload File
                    </ModalHeader>
                    <ModalBody>
                        <Input
                            type="file"
                            accept=".xlsx,.csv"
                            onChange={handleFileChange}
                        />
                    </ModalBody>
                    {uploading ? (
                        <Loader />
                    ) : (
                        <>
                            {bulkupload &&
                                Object.keys(bulkupload).length > 0 && (
                                    <>
                                        <Card className="mx-2">
                                            <CardHeader>
                                                {" "}
                                                Uploading Status:
                                            </CardHeader>
                                            <CardBody
                                                style={{ backgroundColor: "#ffeeba" }}
                                            >
                                                {bulkupload.message
                                                    ? bulkupload.message
                                                    : ""}
                                            </CardBody>
                                        </Card>

                                        <Card className="mx-2">
                                            <CardHeader>
                                                {" "}
                                                Duplicate Customers:
                                            </CardHeader>
                                            <CardBody
                                                style={{ backgroundColor: "#d4edda" }}
                                            >
                                                <ul>
                                                    {bulkupload.duplicateCustomerMsg &&
                                                        bulkupload.duplicateCustomerMsg
                                                            .length > 0 ? (
                                                        bulkupload.duplicateCustomerMsg.map(
                                                            (msg, index) => (
                                                                <div key={index}>
                                                                    <li>
                                                                        {" "}
                                                                        {msg
                                                                            .split("")
                                                                            .map((letter, index) => (
                                                                                <span
                                                                                    key={index}
                                                                                    style={{
                                                                                        color: "blue",
                                                                                    }}
                                                                                >
                                                                                    {letter}
                                                                                </span>
                                                                            ))}
                                                                    </li>
                                                                </div>
                                                            )
                                                        )
                                                    ) : (
                                                        <div>No duplicate Customers</div>
                                                    )}
                                                </ul>
                                            </CardBody>
                                        </Card>

                                        <Card className="mx-2">
                                            <CardHeader>
                                                Partial Duplicate Customers:
                                            </CardHeader>
                                            <CardBody
                                                style={{ backgroundColor: "#cfe2f3" }}
                                            >
                                                <ul>
                                                    {bulkupload.partiallyDublicateCustomerMsg &&
                                                        bulkupload
                                                            .partiallyDublicateCustomerMsg
                                                            .length > 0 ? (
                                                        bulkupload.partiallyDublicateCustomerMsg.map(
                                                            (msg, index) => (
                                                                <div key={index}>
                                                                    <li>
                                                                        {" "}
                                                                        {msg
                                                                            .split("")
                                                                            .map((letter, index) => (
                                                                                <span
                                                                                    key={index}
                                                                                    style={{
                                                                                        color: "black",
                                                                                    }}
                                                                                >
                                                                                    {letter}
                                                                                </span>
                                                                            ))}
                                                                    </li>
                                                                </div>
                                                            )
                                                        )
                                                    ) : (
                                                        <div>
                                                            No Partial duplicate Customers
                                                        </div>
                                                    )}
                                                </ul>
                                            </CardBody>
                                        </Card>

                                        <Card className="mx-2">
                                            <CardHeader
                                                style={{ backgroundColor: "#f8d7da" }}
                                            >
                                                Failed Customers:
                                            </CardHeader>
                                            <CardBody>
                                                <ul>
                                                    {bulkupload.FailedCustomerMsg &&
                                                        bulkupload.FailedCustomerMsg.length >
                                                        0 ? (
                                                        bulkupload.FailedCustomerMsg.map(
                                                            (msg, index) => (
                                                                <div key={index}>
                                                                    <li>
                                                                        {" "}
                                                                        {msg
                                                                            .split("")
                                                                            .map((letter, index) => (
                                                                                <span
                                                                                    key={index}
                                                                                    style={{
                                                                                        color: "red",
                                                                                    }}
                                                                                >
                                                                                    {letter}
                                                                                </span>
                                                                            ))}
                                                                    </li>
                                                                </div>
                                                            )
                                                        )
                                                    ) : (
                                                        <div>No Failed Customers</div>
                                                    )}
                                                </ul>
                                            </CardBody>
                                        </Card>
                                    </>
                                )}
                        </>
                    )}

                    <ModalFooter>
                        <Button color="primary" onClick={downloadCSV}>
                            Download Format
                        </Button>
                        <Button color="primary" onClick={handleFileUpload}>
                            Upload
                        </Button>
                        <Button color="secondary" onClick={toggleModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>

            {/* Revert Bulk Upload Modal */}
            <div>
                <Modal isOpen={revertModal} toggle={() => setRevertModal(false)}>
                    <ModalHeader tag={"h4"} toggle={() => setRevertModal(false)}>
                        Do you wants to revert this bulk upload ?
                    </ModalHeader>

                    <ModalBody>
                        <table className='w-100'>
                            <tr>
                                <td className='fw-bold'>File Name</td>
                                <td>: {selectedBulk && selectedBulk.filename ? selectedBulk.filename : ""}</td>
                            </tr>

                            <tr>
                                <td className='fw-bold'>Upload Name</td>
                                <td className='text-wrap'>: {selectedBulk && selectedBulk.upload_name ? selectedBulk.upload_name : ""}</td>
                            </tr>
                        </table>
                    </ModalBody>

                    <ModalFooter>
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <Button color='danger' onClick={HandleRevertBulk}>Revert Now</Button>
                            <Button color='primary' onClick={() => setRevertModal(false)}>Cancel</Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    )
}

export default CustBulkUpload